import React from 'react';
import { useTranslation } from 'react-i18next';

const NoItemsFound = () => {
const { t } = useTranslation();
return (
      <div className="empty-results-wrapper" style={{textAlign: 'left'}}>
        <div className="no-search-results-wrapper">
            <div className="no-search-results">{t("No items found")}</div>
        </div>
      </div>
);
}

export default NoItemsFound;
